import React, {useEffect} from 'react'
import { TextField, Button, Box } from '@mui/material'
import { useForm } from "react-hook-form";
import { getCoupons, validateCoupon } from '../services/api';
import { useState, useContext } from 'react';
import ComponentLoader from '../components/ComponentLoader';
import { CommonContext } from '../contexts/CommonContext';
import NavHeader from '../components/NavHeader';
import { AuthContext } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom'

function ApplyCoupon() {

  const { register : registerCoupon, handleSubmit : submitCoupon, reset : resetCoupon, formState : {errors:errorsCoupon} } = useForm()
  const [loading, setLoading] = useState(true)
  const [coupons, setCoupons] = useState([])
  const { showLoader, cartData, addCouponToCart, showAlert, updateCart, hideLoader, hideAlert, showSnackbar } = useContext(CommonContext)
  const { isUserLoggedIn, getUserId } = useContext(AuthContext)
  const navigate = useNavigate()

  const getCartSkus = () => {
    const aggregateKeys = [
      "totalCount",
      "totalAmount",
      "totalBasePrice",
      "totalExtras",
      "totalDiscount",
      "bogoDiscount",
    ]
    return Object.keys(cartData || {}).filter(
      (k) => !aggregateKeys.includes(k)
    )
  }

  const navToAuth = async () => {
    if (await isUserLoggedIn()) {
      hideAlert()
      showSnackbar("Login successfull, continue")
    } else {
      hideAlert()
      navigate("/auth")
    }
  }

  const verifyCoupon = async (couponData) => {
    const code = (couponData.couponCode || "").toUpperCase().trim()
    if (!code) {
      showAlert("Please enter a coupon code")
      return
    }

    if (!(await isUserLoggedIn())) {
      showAlert(
        <>
          Please signup / login to use this coupon
          <Button
            variant="contained"
            sx={{ marginTop: "10px" }}
            onClick={() => navToAuth()}
          >
            Login / Signup
          </Button>
        </>
      )
      return
    }

    showLoader()
    try {
      const mobile = await getUserId()
      const skus = getCartSkus()
      const cartTotal = (cartData?.totalBasePrice || 0) + (cartData?.totalExtras || 0)

      const response = await validateCoupon(mobile, code, skus, cartTotal)

      const couponCode =
        response.couponCode || response.coupon?.couponCode || code
      const couponValue =
        response.couponValue ?? response.coupon?.couponValue ?? 0

      if (response.freeSku) {
        updateCart(response.freeSku, true)
      }

      await addCouponToCart({ couponCode, couponValue })
      setTimeout(() => {
        window.history.back()
      }, 2000)

      showAlert("Coupon Applied Successfully")
    } catch (error) {
      showAlert(
        error?.data?.message ||
          error?.message ||
          "Invalid coupon code. Please enter a valid one"
      )
    } finally {
      hideLoader()
    }
  }

  const getUserCoupons = async () => {
    //TODO
    const params = {
      customerId : '0'
    }
    let resp = await getCoupons(params)
    if (cartData['C090']) {
      resp.coupons.push({
        couponCode  : 'HEALTHYEATS',
        couponValue : 200,
        couponTitle : 'HEALTHYEATS'
      })
    } else if (cartData['C091']) {
      resp.coupons.push({
        couponCode  : 'HEALTHYEGGS',
        couponValue : 150,
        couponTitle : 'HEALTHYEGGS'
      })
    }
    setCoupons(resp.coupons)
    setLoading(false)
  }

  useEffect(() => {
    getUserCoupons()
  }, [])

  return (
    <Box sx={{padding:'4vw'}}>
      <NavHeader />
      {
        loading ? 
        <ComponentLoader /> :
        <Box sx={{maxWidth:'600px', marginTop:'7vh'}}>
          <form onSubmit={submitCoupon(verifyCoupon)}>
            <h3>Apply Coupon</h3>
            <Box mb={3}>
              <TextField
                placeholder="Enter coupon code"
                label="Coupon Code"
                variant="outlined"
                fullWidth
                type="text"
                inputProps={{ style: { textTransform: "uppercase" } }}
                autoComplete='off'
                name="couponCode"
                {...registerCoupon("couponCode", {
                  required: "Required field"})}
                error={Boolean(errorsCoupon?.couponCode)}
                helperText={errorsCoupon?.couponCode?.message}
              />
              <Button type="submit" variant="contained" color="primary" 
                sx={{marginTop:'15px'}}>
                Check Coupon
              </Button>
            </Box>
            <h3>Available Coupons</h3>
            <Box>
              {
                coupons.length ?
                coupons.map((coupon) => {
                  if (!coupon.hideCoupon)
                  return (
                    <Box key={coupon.iD} sx={{
                          border:'1px solid #8f8f8f', borderRadius:'10px', padding:'20px', display:'flex', 
                          marginBottom:'10px',
                          justifyContent:'space-between', alignItems:'center'}}>
                      <Box sx={{width:'60%'}}>
                        {coupon.couponTitle}
                      </Box>
                      <Box sx={{width:'30%', textAlign:'right'}}>
                        <Button variant='contained' onClick={() => verifyCoupon({couponCode : coupon.couponCode})}>Apply</Button>
                      </Box>
                    </Box>
                  ) 
                }) : 
                <Box>
                  No Coupons Found
                </Box>
              }
            </Box>
          </form>
        </Box>
      }
      </Box>
  )
}

export default ApplyCoupon